import { render, staticRenderFns } from "./Modais.vue?vue&type=template&id=4904273a&scoped=true"
import script from "./Modais.vue?vue&type=script&lang=js"
export * from "./Modais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4904273a",
  null
  
)

export default component.exports